import React, { Suspense, lazy } from "react";
import { Redirect, Switch, Route } from "react-router-dom";

import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";

const ChurchesPage = lazy(() => import("./icomos/pages/churches/ChurchesPage"));

const ChurchView = lazy(() =>
  import("./icomos/pages/churches/church-view/ChurchView")
);

const MapsPage = lazy(() => import("./icomos/pages/maps/MapsPage"));
const HomePage = lazy(() => import("./icomos/pages/home/HomePage"));
const ZaProektotPage = lazy(() => import("./icomos/pages/za-proektot/zaProektotPage"));

export default function BasePagePublic() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {
          /* Redirect from root URL to /home. */
          <Redirect exact from="/" to="/home" />
        }
        <Route path="/home" component={HomePage} />

        {/* icomos routes */}
        {/* churches - START*/}

        <ContentRoute path="/map/churches/:id/view" component={ChurchView} />
        <ContentRoute path="/churches/:id/view" component={ChurchView} />
        <ContentRoute path="/churches" component={ChurchesPage} />
        <Route path="/za-proektot" component={ZaProektotPage} />

        {/* churches - END*/}

        <Route path="/maps" component={MapsPage} />

        <Redirect to="error/error-v1" />
      </Switch>
    </Suspense>
  );
}
